import { apiRequest } from "../../utils/apiService";

class MeService {

  static async getMe() {
    return await apiRequest("/api/me", { method: "GET" });
  }
}

export default MeService;